import { useAuthStore } from '@/stores/auth'
import { clearSheets } from '@/composables/sheet-stack'
import type {
  NavigationGuardNext,
  RouteLocationNormalized,
  RouteLocationNormalizedLoaded,
} from 'vue-router'

export function closeSheets(
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalizedLoaded,
  next: NavigationGuardNext,
) {
  clearSheets()
  next()
}

export function requireAuth(
  to: RouteLocationNormalized,
  _from: RouteLocationNormalizedLoaded,
  next: NavigationGuardNext,
) {
  const authStore = useAuthStore()

  // Check if route requires authentication
  const requiresAuth = to.meta.requireAuth !== false

  if (requiresAuth && !authStore.isAuthorized) {
    // Redirect to login if not authorized, with redirect query param
    next({ name: 'signin', query: { redirect: to.fullPath } })
  } else if (to.name === 'signin' && authStore.isAuthorized) {
    // If already authorized and trying to access login, redirect to events
    next({ name: 'companies' })
  } else {
    next()
  }
}
